import React from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * Persistent, non-dismissible SANDBOX banner.
 *
 * Shown whenever the authenticated user belongs to the demo tenant. The signal
 * is `user.is_demo`, computed server-side in /api/check-auth from the user's
 * resolved tenant (slug 'demo' / features.isDemo). We also accept the tenant
 * slug as a fallback. There is intentionally NO dismiss control.
 */
const DemoBanner = () => {
  const { user } = useAuth();
  const isDemo = user?.is_demo === true || user?.tenant === 'demo';

  if (!isDemo) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="w-full bg-amber-500 text-amber-950 text-center text-xs sm:text-sm font-semibold px-4 py-2 shadow-sm select-none"
      style={{ letterSpacing: '0.03em' }}
    >
      <span aria-hidden="true">🧪 </span>
      DEMO / SANDBOX — sample data, no real transactions
    </div>
  );
};

export default DemoBanner;
